import React from 'react'

export default function CopyLinkIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.6 12H15.4M9.45 8.5H6.9C5.99826 8.5 5.13346 8.86875 4.49584 9.52513C3.85821 10.1815 3.5 11.0717 3.5 12C3.5 12.9283 3.85821 13.8185 4.49584 14.4749C5.13346 15.1313 5.99826 15.5 6.9 15.5H9.45M14.55 8.5H17.1C18.0017 8.5 18.8665 8.86875 19.5042 9.52513C20.1418 10.1815 20.5 11.0717 20.5 12C20.5 12.9283 20.1418 13.8185 19.5042 14.4749C18.8665 15.1313 18.0017 15.5 17.1 15.5H14.55" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}
